import Vue from 'vue';

import core from '@/framework/core';

import routerInstance from '@/framework/router';
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import axios from 'axios';

import { baseUrlFull } from '@/ajax/baseUrl';
import { authorizationStorage, userInfoStorage, xTokenStorage } from './storages/sessionStorage';
import { menuRightsStorage } from './storages/localStorage';
import {
  clearLegacyBackofficeSession,
  validateWeComSession,
} from '@/features/auth/wecomSessionBootstrap.mjs';

NProgress.configure({ showSpinner: false });

routerInstance.beforeEach(async (to, from, next) => {
  NProgress.start();
  let xToken = xTokenStorage.get();
  if (!xToken) {
    // The bootstrap page receives an HttpOnly server cookie before legacy storage exists.
    if (to.name === 'login' || to.name === 'wecomSession') {
      next();
    } else {
      next({
        name: 'login',
      });
    }
    return;
  }

  const profile = userInfoStorage.get();
  const sessionIsValid = await validateWeComSession(profile, async () => {
    const response = await axios.get(`${baseUrlFull}/backoffice/auth/me`, { withCredentials: true });
    return response.data;
  });
  if (!sessionIsValid) {
    clearLegacyBackofficeSession({
      userInfoStorage,
      authorizationStorage,
      menuRightsStorage,
      xTokenStorage,
    });
    next({ name: 'login' });
    return;
  }

  next();
});

routerInstance.afterEach(() => {
  NProgress.done();
});

// core.methods = {};
// core.mounted = function () {};

new Vue(core);
